import * as React from 'react';
import { SVGProps } from 'react';

const IconFlagStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.333 2 8 4l1.333 2L10 7H3v4H2V1h8l-.667 1zM7.168 4.555 8.13 6H3V2h5.131l-.963 1.445-.37.555.37.555z"
    />
  </svg>
);
export default IconFlagStrokedSizeXs;
